(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom_4_tab"] && !Shopify.designMode) return;
  try {
    
// Robust tab activator for .multi-tabs-section
(function() {
  // Helpers
  const log = (...args) => {
    // comment out next line to silence logs later
    console.info('[Tabs]','', ...args);
  };

  const activateTabById = (id) => {
    if (!id) return false;
    const btn = document.querySelector(`.tab[data-tab="${id}"]`);
    const content = document.getElementById(id);
    if (btn && content) {
      // prefer triggering click so theme's own handlers run
      try {
        btn.click();
        log('Activated by click:', id);
      } catch (e) {
        // fallback to manual class toggle
        document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.tabs-content').forEach(c => c.classList.remove('active'));
        btn.classList.add('active');
        content.classList.add('active');
        log('Activated by class toggle (fallback):', id);
      }
      return true;
    }
    log('No matching button/content for id:', id);
    return false;
  };

  const getHashId = () => {
    // handle encoded anchors and leading # 
    return decodeURIComponent(window.location.hash || '').replace(/^#/, '');
  };

  // Wait until the tabs exist (with timeout)
  const waitForTabs = (timeout = 3000) => {
    return new Promise((resolve) => {
      const start = Date.now();
      const check = () => {
        const tabsExist = document.querySelectorAll('.multi-tabs-section .tab').length > 0 &&
                          document.querySelectorAll('.multi-tabs-section .tabs-content').length > 0;
        if (tabsExist) {
          resolve(true);
          return;
        }
        if (Date.now() - start > timeout) {
          resolve(false);
          return;
        }
        requestAnimationFrame(check);
      };
      check();
    });
  };

  const init = async () => {
    // Ensure theme's markup is available
    const ready = await waitForTabs(4000);
    if (!ready) {
      log('Tabs not present within timeout. Will try again on DOM changes.');
      // set up MutationObserver to try again once nodes appear
      const obs = new MutationObserver((mutations, o) => {
        if (document.querySelectorAll('.multi-tabs-section .tab').length > 0) {
          o.disconnect();
          init(); // retry init
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      return;
    }

    // Attach click handlers (if not already attached). This is idempotent.
    document.querySelectorAll('.tab').forEach(tab => {
      if (!tab.__hasTabHandler) {
        tab.addEventListener('click', () => {
          const target = tab.getAttribute('data-tab');
          document.querySelectorAll('.tab').forEach(t => t.classList.remove('active'));
          document.querySelectorAll('.tabs-content').forEach(c => c.classList.remove('active'));
          tab.classList.add('active');
          const el = document.getElementById(target);
          if (el) el.classList.add('active');
        });
        tab.__hasTabHandler = true;
      }
    });

    // If URL has hash when loading, try to activate it
    const initialHash = getHashId();
    if (initialHash) {
      const ok = activateTabById(initialHash);
      if (ok) {
        // scroll into view a little after activation so layout settles
        setTimeout(() => {
          document.querySelector('.multi-tabs-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    }

    // Listen for hash changes (user clicks menu or browser back/forward)
    window.addEventListener('hashchange', () => {
      const h = getHashId();
      if (!h) return;
      activateTabById(h);
      // small scroll to tab section after activation
      setTimeout(() => document.querySelector('.multi-tabs-section')?.scrollIntoView({ behavior: 'smooth', block: 'start' }), 150);
    });

    // Some Shopify themes use history API/navigation without full page reloads.
    // Ensure we catch popstate as well.
    window.addEventListener('popstate', () => {
      const h = getHashId();
      if (h) activateTabById(h);
    });

    log('Tab script initialized.');
  };

  // Kick off when DOM is ready (safe to run without multiple listeners)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
